import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledSearchContainer = styled.div`
  position: relative;
  margin-bottom: 32px;
`;

const StyledSearchBox = styled(Input)`
  height: 56px;
  border-radius: 28px !important;
  border: 2px solid #e2e8f0 !important;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  font-size: 16px;
  padding: 0 24px 0 56px !important;
  box-shadow: 0 8px 32px rgba(0,0,0,0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: 'Inter', 'SF Pro Display', 'Alibaba PuHuiTi', 'Arial', sans-serif;
  
  &::placeholder {
    color: #94a3b8;
    font-weight: 400;
  }
  
  &:hover {
    border-color: #6366f1 !important;
    box-shadow: 0 12px 40px rgba(99, 102, 241, 0.15);
    transform: translateY(-2px);
  }
  
  &:focus {
    border-color: #6366f1 !important;
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1), 0 12px 40px rgba(99, 102, 241, 0.15);
    transform: translateY(-2px);
  }
`;

const SearchIcon = styled(SearchOutlined)`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #6366f1;
  z-index: 1;
  pointer-events: none;
`;

const SearchBox = ({ placeholder = "搜索装备/品牌/型号/性别/颜色/技术信息...", onFocus, ...props }) => {
  return (
    <StyledSearchContainer>
      <SearchIcon />
      <StyledSearchBox
        placeholder={placeholder}
        onFocus={onFocus}
        {...props}
      />
    </StyledSearchContainer>
  );
};

export default SearchBox;